// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7s-0";
export var startPickingButton = "_7s-1";